import { ref, computed } from 'vue';

export function useHistory(initialState) {
  const history = ref([]);
  const currentIndex = ref(-1);
  
  const canUndo = computed(() => currentIndex.value > 0);
  const canRedo = computed(() => currentIndex.value < history.value.length - 1);
  
  function pushHistory() {
    // Remove any "future" history if we're not at the end
    if (currentIndex.value < history.value.length - 1) {
      history.value = history.value.slice(0, currentIndex.value + 1);
    }
    
    // Add current state (deep clone)
    history.value.push(JSON.parse(JSON.stringify(initialState.value)));
    currentIndex.value = history.value.length - 1;
    
    // Limit history size to 50 states
    if (history.value.length > 50) {
      history.value.shift();
      currentIndex.value--;
    }
  }
  
  function undo() {
    if (canUndo.value) {
      currentIndex.value--;
      return JSON.parse(JSON.stringify(history.value[currentIndex.value]));
    }
    return null;
  }
  
  function redo() {
    if (canRedo.value) {
      currentIndex.value++;
      return JSON.parse(JSON.stringify(history.value[currentIndex.value]));
    }
    return null;
  }
  
  function clearHistory() {
    history.value = [];
    currentIndex.value = -1;
  }
  
  return {
    history,
    currentIndex,
    canUndo,
    canRedo,
    pushHistory,
    undo,
    redo,
    clearHistory
  };
}

